import { EColumnType } from './types';
import { PADDING_LEFT } from './constants';

export const getValueAlignment = (item, isDetailsTable): {} => {
  let style = {} as { textAlign?: string; paddingLeft?: number; top?: number };
  if (isDetailsTable) {
    style =
      item.format === EColumnType.Text ? { textAlign: 'left', paddingLeft: PADDING_LEFT } : { textAlign: 'right' };
  }
  return style;
};
